import React from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"

interface FileUploaderProps {
  handleFile: (files: FileList) => void
  children: React.ReactElement
  accept: string
  tooltip?: string | null
  multiple?: boolean
}

const FileUploader = ({ handleFile, children, accept, tooltip, multiple = true }: FileUploaderProps) => {
  const hiddenFileInput = React.useRef<HTMLInputElement>(null)

  const handleClick = () => {
    hiddenFileInput.current?.click()
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      handleFile(event.target.files)
    }
  }

  return (
    <>
      {tooltip ? (
        <OverlayTrigger placement="right" overlay={<Tooltip id="file-uploader-tooltip">{tooltip}</Tooltip>}>
          {React.cloneElement(children as React.ReactElement<Record<string, unknown>>, { onClick: handleClick })}
        </OverlayTrigger>
      ) : (
        React.cloneElement(children as React.ReactElement<Record<string, unknown>>, { onClick: handleClick })
      )}
      <input
        multiple={multiple}
        accept={accept}
        type="file"
        ref={hiddenFileInput}
        onChange={handleChange}
        style={{ display: "none" }}
      />
    </>
  )
}

export default FileUploader
